const CLICK_OVERVIEW = 'Click Overview';
const CLICK_DETAILS_ON_INSPECTIONS_CARD = 'Click on Details on the Safety Inspections Card';
const CLICK_DETAILS_ON_TRAININGS_CARD = 'Click on Details on the Safety Trainings Card';
const CLICK_DETAILS_ON_OBSERVATIONS_CARD = 'Click on Details on the Observations Card';
const CLICK_OPEN_INCIDENTS = 'Click on Open Incidents Ribbon';
const CLICK_AWAITING_REVIEW = 'Click on Awaiting Review Ribbon';
const CLICK_REVIEWED_INCIDENTS = 'Click on Reviewed Incidents Ribbon';
const CLICK_DETAILS_ON_JSA_REVIEW_CARD = 'Click on Details on the JSA Review Card';

const safetyAnalyticConstent = {
  CLICK_OVERVIEW,
  CLICK_DETAILS_ON_INSPECTIONS_CARD,
  CLICK_DETAILS_ON_TRAININGS_CARD,
  CLICK_DETAILS_ON_OBSERVATIONS_CARD,
  CLICK_OPEN_INCIDENTS,
  CLICK_AWAITING_REVIEW,
  CLICK_REVIEWED_INCIDENTS,
  CLICK_DETAILS_ON_JSA_REVIEW_CARD,
};
export default safetyAnalyticConstent;
